import React from 'react';
import styled, { keyframes } from 'styled-components';
import { assets } from '../../assets';

const ErrorIcon = styled.img`
  width: 14px;
  height: 14px;
  margin-right: 4px;
`;

const growAnimation = keyframes`
  from {
    max-height: 0px;
  }

  to {
    max-height: 100px;
  }
`;

const ErrorContainer = styled.div`
  animation: ${growAnimation} 1.5s ease-out 0s 1;
`;

const ErrorShower = (props: {
  error?: string;
  className?: string;
  style?: React.CSSProperties;
  bigger?: boolean;
}): JSX.Element | null => {
  if (!props.error) {
    return null;
  }

  return (
    <ErrorContainer
      className={'flex flex-row items-center mt-2' + (props.className ? ' ' + props.className : '')}
      style={props.style}
    >
      <ErrorIcon src={assets.icons.error_icon} />
      <p className={(props.bigger ? 'text-16 ' : 'text-10 ') + 'text-error'}>{props.error}</p>
    </ErrorContainer>
  );
};

export default ErrorShower;
